import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Default language strings for components
///////////////////////////////////////////////////////////////////////////////////////////

const BG = {
	oneYear: 'за една година',
	twoYears: 'за две години',
	threeYears: 'за три години',
	fourYears: 'за четири години',
	from: 'От',
	lv: 'лв',
	leva: 'лева',
	evro: 'евро',
	lvY: 'лв/год',
	lvM: 'лв/мес',
	eurY: 'евро/год',
	eurM: 'евро/мес',
	plan: 'план',
	ssdDisk: 'SSD диск',
	monthTraffic: 'трафик/мес',
	price: 'цена',
	cpuCores: 'ядра',
	cpuCore: 'ядро',
	advantages: 'Предимства',
	plansAndPrices: 'Планове и цени',
	typesAndPrices: 'Видове и цени',
	faq: 'Въпроси и отговори',
	emptyCart: 'Количката е празна',
	all: 'Всички',
	domainTld: 'домейн област',
	registration: 'регистрация',
	renew: 'подновяване',
	transfer: 'трансфер',
	term: 'период',
	oneYearTerm: '1 година',
	twoYearsTerm: '2 години',
	threeYearsTerm: '3 години',
	fourYearsTerm: '4 години',
	fiveYearsTerm: '5 години',
	sixYearsTerm: '6 години',
	sevenYearsTerm: '7 години',
	eightYearsTerm: '8 години',
	nineYearsTerm: '9 години',
	tenYearsTerm: '10 години',
	allDomains: 'Всички домейни',
	clickForMoreInfo: 'Кликнете за повече информация',
	viewPlansAndPrices: 'Виж планове и цени',
	dotLoading: 'Зареждане...',
	viewMore: 'Виж повече',
	back: 'Назад',
	promoPrice: 'AI Birthday Bundle',
	renewalPrices: 'Цени за подновяване',
	month: 'месец',
	months: 'месеца',
	shBGTitle: ' - СуперХостинг.БГ',
	orderFrom: 'Поръчай от',
	accessibility: 'Достъпност',
	privacy: 'Поверителност',
	search: 'Търсене',
	closeMsg: 'Затвори',
	confirmMsg: 'Потвърди',
};

///////////////////////////////////////////////////////////////////////////////////////////

const EN = {
	oneYear: 'for one year',
	twoYears: 'for two years',
	threeYears: 'for three years',
	fourYears: 'for four years',
	from: 'From',
	lv: 'bgn',
	leva: 'bgn',
	evro: 'eur',
	lvY: 'bgn/yr',
	lvM: 'bgn/mo',
	eurY: 'eur/yr',
	eurM: 'eur/mo',
	plan: 'Plan',
	ssdDisk: 'SSD Disk',
	monthTraffic: 'Traffic/mo',
	price: 'Price',
	cpuCores: 'cores',
	cpuCore: 'core',
	advantages: 'Advantages',
	plansAndPrices: 'Plans and prices',
	typesAndPrices: 'Types and prices',
	faq: 'FAQ',
	emptyCart: 'Cart is empty',
	all: 'All',
	domainTld: 'domain tld',
	registration: 'registration',
	renew: 'renewal',
	transfer: 'transfer',
	term: 'term',
	oneYearTerm: '1 year',
	twoYearsTerm: '2 years',
	threeYearsTerm: '3 years',
	fourYearsTerm: '4 years',
	fiveYearsTerm: '5 years',
	sixYearsTerm: '6 years',
	sevenYearsTerm: '7 years',
	eightYearsTerm: '8 years',
	nineYearsTerm: '9 years',
	tenYearsTerm: '10 years',
	allDomains: 'All domains',
	clickForMoreInfo: 'Click for more info',
	viewPlansAndPrices: 'View Plans & Pricing',
	dotLoading: 'Loading...',
	viewMore: 'Learn more',
	back: 'Back',
	promoPrice: 'AI Birthday Bundle',
	renewalPrices: 'Renewal prices',
	month: 'month',
	months: 'months',
	shBGTitle: ' - SuperHosting.BG',
	orderFrom: 'Order from',
	accessibility: 'Accessibility',
	privacy: 'Privacy',
	search: 'Search',
	closeMsg: 'Close',
	confirmMsg: 'Confirm',
};

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];